// extracted by mini-css-extract-plugin
export default {"test":"test_test__nDnEJ"};